import React, {  ChangeEvent, useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { forEachChild } from 'typescript';

interface inputAndSelectorProps {
    options: string[],
    initialTextPerOption: Record<string, string>,
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const InputWithSelectorField = (props: inputAndSelectorProps) => {
    const ENTER_KEY = 13

    const [texts, setTexts] = useState<Record<string, string>>(props.initialTextPerOption);
    const [result, setResult] = useState<string>("");
    const [select, setSelect] = useState<string>("0");
    const [changed, setChanged] = useState<boolean>(false);
    // Carries the JSON of all languages to onChange, so the visible box keeps showing only the selected language's text
    const hiddenInput = useRef<HTMLInputElement>(null);

    const { options } = props;

    const handleBlur = (e: React.FocusEvent) => {
        triggerChange();
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === ENTER_KEY) {
            triggerChange();
        }
    }

    const triggerChange = () => {
        if (!changed || hiddenInput.current == null) {
            return;
        }

        hiddenInput.current.value = JSON.stringify(texts);
        props.onChange({ target: hiddenInput.current, currentTarget: hiddenInput.current } as ChangeEvent<HTMLInputElement>);
    }

    return (
        <div style={{ display: 'flex' }}>
            {options.map((key, i) => (
                select === i.toString() && (
                    <Form.Control
                        type="text"
                        size="sm"
                        style={{ width:'90%' }}
                        value={texts[key]}
                        onChange={(e) => {
                            setTexts(
                                values => ({ ...values, [key]: e.target.value })
                            );

                            setChanged(true);
                        }}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                    />
                )))}
            <select className="form-control" style={{ width: '10%' }} value={select} onChange={(e) => { setSelect(e.target.value); }}>
                {options.map((text, i) => (
                    <option label={text} value={i} key={i} />
                ))}
            </select>            
            <input type="hidden" ref={hiddenInput} />
        </div>
    );
}


export default InputWithSelectorField;